var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-fullscreen"},[_c('div',{staticClass:"message-content",domProps:{"innerHTML":_vm._s(_vm.activity.flag)}})])}
var staticRenderFns = []

export { render, staticRenderFns }